import { setupIosSelectKeyboardFix } from "@iso/lib/helpers/utility";

// Entry point for app-wide platform bug fixes. Mount once from AppProvider via useEffect.
// To add a fix: implement setupXxxFix() (returns a teardown fn) and register it in teardowns.
export function setupAppPlatformFixes() {
  const teardowns = [
    setupIosSelectKeyboardFix(),
  ];

  return () => {
    teardowns.forEach((teardown) => teardown());
  };
}
